import TariffStripeSettings from './TariffStripeSettings';

export default TariffStripeSettings;
